import { createFileRoute, redirect } from '@tanstack/react-router'
import { GrosirLandingPage, buildGrosirLpHead, loadGrosirLpData } from '../components/GrosirLp'
import { getGrosirLandingPath, TOP_LEVEL_GROSIR_SLUGS } from '../lib/grosirLanding'
import { storefrontResponseHeaders } from '../lib/storefrontResponse'

export const Route = createFileRoute('/lp/grosir-{$slug}')({
  beforeLoad: ({ params }) => {
    if (TOP_LEVEL_GROSIR_SLUGS.has(params.slug)) {
      throw redirect({ href: getGrosirLandingPath(params.slug), statusCode: 301 })
    }
  },
  loader: ({ params }) => loadGrosirLpData(params.slug),
  headers: ({ loaderData }) => storefrontResponseHeaders(loaderData?.productsUnavailable ?? false),
  head: ({ loaderData, params }) =>
    buildGrosirLpHead({ loaderData, slug: params.slug, path: `/lp/grosir-${params.slug}` }),
  component: LandingPageRoute,
})

function LandingPageRoute() {
  const data = Route.useLoaderData()
  return <GrosirLandingPage key={data.routeSlug} data={data} />
}
